// AdminLayoutでbase layerのCSSを読み込むように変更したため、*.layer.cssを削除しても問題ないが、
// UI側のスタイルが崩れるため一旦残しておく
// Admin画面からmantineの依存を消しすときに削除する
import "@mantine/core/styles.layer.css";
import "@mantine/dropzone/styles.layer.css";
import "@mantine/notifications/styles.layer.css";
import "@/index.css";
import "./i18n"; // i18nの初期化
import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";

if (import.meta.env.VITE_ENABLE_DATADOG === "true") {
  datadogRum.init({
    applicationId: import.meta.env.VITE_DD_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
    site: import.meta.env.VITE_DD_SITE,
    service: import.meta.env.VITE_DD_SERVICE_NAME,
    env: import.meta.env.VITE_DD_ENV,
    version: import.meta.env.VITE_DD_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: import.meta.env.VITE_DD_ALLOWED_TRACING_URLS.split(","),
    traceSampleRate: 100,
    plugins: [reactPlugin({ router: true })],
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
